const ConverteDataFunction = (date) => new Date(date).toLocaleDateString('pt-BR', { timeZone: 'UTC' })

export default ConverteDataFunction